import React from "react";
import { Link } from "react-router-dom";
import AdminProfile from "./AdminProfile";

const AdminDashboard = () => {
  return (
    <div>
      <div className="container mt-3">
        <h3 className="text-muted mb-3">Admin Dashboard</h3>
        <div className="row">
          <div className="col-sm-3">
            <ul className="list-group">
              <li className="list-group-item">
                <Link to="/create/city" className="nav-link text-success">
                  <b>
                    <i class="fas fa-city"></i> Create City
                  </b>
                </Link>
              </li>
              <li className="list-group-item">
                <Link to="/create/category" className="nav-link text-success">
                  <b>
                    <i class="fas fa-search-location"></i> Create Area
                  </b>
                </Link>
              </li>
              <li className="list-group-item">
                <Link to="/create/room" className="nav-link text-success">
                  {" "}
                  <b>
                    <i class="fas fa-home"></i> Add Room
                  </b>
                </Link>
              </li>
              <li className="list-group-item">
                <Link to="/list/rooms" className="nav-link text-success">
                  {" "}
                  <b>
                    <i class="fas fa-home"></i> <i class="fas fa-home"></i> List
                    Rooms
                  </b>
                </Link>
              </li>
              <li className="list-group-item">
                <Link to="/lists/room/orders" className="nav-link text-success">
                  {" "}
                  <b>
                    <i class="fas fa-key"></i> <b>Room booked</b>
                  </b>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-sm-9">
            <AdminProfile />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
